export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.97747cf5.jpg";